import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, MenuItem, ListItemText, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useTableQueryingContext } from '@/components/app-context/TableQueryContext'
import { useTheme } from '@mui/material'
import { useAuth } from '@/components/app-context/AuthContext'

const RoleSelector = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const theme = useTheme()

  const [anchorEl, setAnchorEl] = useState(null)
  const [pendingRole, setPendingRole] = useState(null)

  const triggerRef = useRef(null)

  const roleDefault = useSelector(({ login }) => login.roles?.[0])
  const rolesPermitted = useSelector(({ login }) => login.rolesPermitted ?? [])
  const open = Boolean(anchorEl)

  const { removeQuerying } = useTableQueryingContext()
  const { changeRol } = useAuth()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = (role) => {
    if (role === roleDefault) {
      handleClose()
      return
    }

    setPendingRole(role)
    handleClose()
  }

  const executeRoleChange = async (role) => {
    removeQuerying()
    changeRol(role).then(() => {
      navigate('/')
    })
  }

  return (
    <>
      <Typography
        ref={triggerRef}
        component="button"
        type="button"
        onClick={handleClick}
        color="white"
        sx={{
          cursor: 'pointer',
          fontWeight: 'bold',
          background: 'transparent',
          border: 0,
          padding: 0,
          [theme.breakpoints.down('sm')]: {
            '&::after': {
              content: `"${roleDefault ? t(roleDefault).slice(0, 2) : ''}"`,
            },
          },
          [theme.breakpoints.up('sm')]: {
            '&::after': {
              content: `"${roleDefault ? t(roleDefault) : ''}"`,
            },
          },
        }}
      />

      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        variant="menu"
        disableAutoFocusItem
        slotProps={{
          paper: {
            sx: { width: '20ch' },
          },
          transition: {
            onExited: () => {
              // restauramos foco a un elemento estable
              triggerRef.current?.focus()

              if (pendingRole) {
                const role = pendingRole
                setPendingRole(null)
                executeRoleChange(role)
              }
            },
          },
        }}>
        {[...new Set(rolesPermitted)]
          .sort((a, b) => t(a).localeCompare(t(b)))
          .map((role) => (
            <MenuItem key={role} onClick={() => handleMenuItemClick(role)} selected={role === roleDefault}>
              <ListItemText primary={t(role)} />
            </MenuItem>
          ))}
      </Menu>
    </>
  )
}

export default RoleSelector
